<script setup lang="ts">
const DEFAULT_QUOTES = [
  {
    imageSrc: transformImage(
      'https://images.grove.co/upload/v1556759672/Product%20Design/careers/Testimonial-Grace.jpg',
      'f_auto,fl_progressive,w_600,q_auto'
    ),
    text: 'Since day one, everyone has made me feel like I was part of a family.',
    author: 'Grace, Business Operations',
  },
  {
    imageSrc: transformImage(
      'https://images.grove.co/upload/v1556759672/Product%20Design/careers/Testimonial-Rob.jpg',
      'f_auto,fl_progressive,w_600,q_auto'
    ),
    text: 'When you work at Grove, you are a person, a person who is changing the Earth and making an impact on customers.',
    author: 'Rob, Operations',
  },
  {
    imageSrc: transformImage(
      'https://images.grove.co/upload/v1556759672/Product%20Design/careers/Testimonial-Karie.jpg',
      'f_auto,fl_progressive,w_600,q_auto'
    ),
    text: 'I finally feel like I have a voice that is heard.',
    author: 'Karie, People Ops',
  },
  {
    imageSrc: transformImage(
      'https://images.grove.co/upload/v1556759670/Product%20Design/careers/Testimonial-Emily.jpg',
      'f_auto,fl_progressive,w_600,q_auto'
    ),
    text: 'We are rooted in respecting one another as well as the planet we share and that fosters a pretty special culture.',
    author: 'Emily, Community Happiness',
  },
]

const { isMediumUp } = useSkyBreakpoint()
</script>

<template>
  <SkyCarousel
    draggable
    pagination
    :navigation="isMediumUp"
    class="CareerQuoteCarousel"
  >
    <div
      v-for="(quote, quoteIndex) in DEFAULT_QUOTES"
      :key="`career-quote-${quoteIndex}`"
      class="CareerQuoteCarousel_Container"
    >
      <div class="CareerQuoteCarousel_Media">
        <SkyImage :src="quote.imageSrc" alt="" />
      </div>
      <div>
        <p class="CareerQuoteCarousel_Quote">“{{ quote.text }}”</p>
        <div class="CareerQuoteCarousel_Author">{{ quote.author }}</div>
      </div>
    </div>
  </SkyCarousel>
</template>

<style lang="scss">
.CareerQuoteCarousel {
  &_Container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: var(--spacing-10x);
    gap: var(--spacing-4x);
    height: 100%;

    @include for-medium-up {
      flex-direction: row;
      gap: var(--spacing-10x);
    }
  }

  &_Media {
    min-width: 100%;

    @include for-medium-up {
      min-width: 400px;
    }
  }

  &_Quote {
    @include type-brand-display('2');
    text-align: center;
    margin-bottom: var(--spacing-8x);
    padding: 0 var(--spacing-4x);

    @include for-medium-up {
      text-align: left;
      margin-bottom: var(--spacing-10x);
      padding: 0;
    }
  }

  &_Author {
    @include type-section('s');
    text-align: center;

    @include for-medium-up {
      text-align: left;
    }
  }
}
</style>
